import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Gtag, Analytics } from '../../compornents/Analytics';
import React from 'react';
import { BAG_FIRST } from '../../bagFirst';

// メニュー選択（bag-first改定 2026-09-01）。
// 改定前は「衣類専用バッグ ¥0 / ふとん専用バッグ ¥330」の2択で、
// 初回の入口が売上ゼロの注文になっていた。改定後は初回990円のコース1本にして、
// 専用バッグはそのコースに無料で付属する扱いにする。
//
// この画面はSMS認証より前＝まだ顧客も配送拠点も確定していないため、
// APIから商品を引くことができない（/order/item.php は要認証）。
// そのため表示は固定で、実際の商品ID・金額は認証後に RegisterProfile が
// /order/item.php のレスポンスから item.type === localStorage('item_type') で解決する。
// ※ふとんコースは拠点によって取扱いが異なり、この時点では拠点が分からないため
//   ここには出さない。登録完了後のホームのメニュー（API駆動）に出る。
export const RegisterMenu = () => {
  const navigate = useNavigate();

  const next = (item_type) => {
    localStorage.setItem('item_type', item_type);
    navigate('/register');
  }

  useEffect(() => {
    Gtag('view_register_menu');
  }, []);

  // ---- 従来メニュー（無料バッグ / ふとん専用バッグ の2択）。現行本番と同一 ----
  if (!BAG_FIRST) {
    return (
      <div className="Register m-auto">
        <Analytics title="メニュー" />
        <div className="App-telno">
          <div className="h5 mt-4 mb-4 text-center">
            <div className="">メニューを<br />お選びください</div>
          </div>
          <div className="mb-4">
            <div className="row">
              <div className="col-6">
                <div className="div_btn" onClick={() => next('bag')}>
                  <div className="mb-2">
                    <img src="/img/items/bag.png" className="ItemImage" alt="Item" />
                  </div>
                  <div className="">
                    <div className="h6">
                      衣類専用バッグ
                    </div>
                    <div className="text-gray-dark">
                      <small>衣類クリーニングはこちら</small>
                    </div>
                    <div className="text-right h6">
                      ¥0<small>(税込)</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="div_btn" onClick={() => next('futon_bag')}>
                  <div className="mb-2">
                    <img src="/img/items/futon_bag_first.png" className="ItemImage" alt="Item" />
                  </div>
                  <div className="">
                    <div className="h6">
                      ふとん専用バッグ
                    </div>
                    <div className="text-gray-dark">
                      <small>ふとんクリーニングはこちら</small>
                    </div>
                    <div className="text-right h6">
                      ¥330<small>(税込)</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-2 h6 text-danger">
            ※数量限定ですので、キャンペーン終了前にお受け取りくださいませ
          </div>
        </div>
      </div>
    );
  }

  // ---- 新メニュー（初回990円コースの1択） ----
  return (
    <div className="Register m-auto">
      <Analytics title="メニュー" />
      <div className="App-telno">
        <div className="h5 mt-4 mb-4 text-center">
          <div className="">初回おためしメニュー</div>
        </div>
        <div className="mb-4">
          <div className="row">
            <div className="offset-1 col-10">
              {/* モック(menu画面)のカード意匠: 枠付きカード＋「初回限定」タグ */}
              <div className="div_btn" onClick={() => next('pack')}
                   style={{ border: '2px solid #f8e100', borderRadius: 12, padding: 12, position: 'relative' }}>
                <span style={{ position: 'absolute', top: -12, left: 12, background: '#f8e100', color: '#1b1c10', fontSize: 12, fontWeight: 700, padding: '2px 10px', borderRadius: 999 }}>初回限定</span>
                <div className="mb-2 mt-2">
                  <img src="/img/2-8.png" className="ItemImage" alt="クリーニング3点で990円" />
                </div>
                <div className="">
                  <div className="h6">
                    新規入会特典｜3点コース
                  </div>
                  <div className="text-gray-dark">
                    <small>
                      1点当たり330円！Yシャツは2枚で1点カウント。<br />
                      今なら専用バッグ無料でお届けします。
                    </small>
                  </div>
                  <div className="text-right h6">
                    ¥990<small>(税込)</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bf-callout mb-4">
          <b>ご利用の流れ</b>
          ご注文後、まず専用バッグを無料でお届けします。届いたら依頼品を入れて、アプリから集荷をご依頼ください。
        </div>
        <div className="text-center">
          <button className="button-next" onClick={() => next('pack')}>
            このメニューではじめる
          </button>
        </div>
      </div>
    </div>
  );
}
